import React, { Component } from 'react';
import { Row, Col, Button, Input } from 'react-bootstrap';
import { Translate } from 'react-redux-i18n';
import ContentWrapper from '../../components/Layout/ContentWrapper';
import { isGGI, isVAK } from '../../actions/root_url';
import Select from 'react-select';
class ConfirmActionModal extends Component {
  static contextTypes = {
    router: React.PropTypes.object
  };

  constructor() {
    super();
    this.state = {
      selected: null
    };
    this.caseAction = this.caseAction.bind(this);
  }

  componentDidMount() {
    // window.addEventListener("keydown", this.handleKeyDown.bind(this));
    let atsHtml = document.getElementById('ats');
    if(atsHtml && atsHtml != null) {
      atsHtml.focus();
    }
  }

  componentWillReceiveProps() {

  }

  componentWillUnmount() {
    // window.removeEventListener('keydown', this.handleKeyDown.bind(this));
  }

  handleKeyDown(event) {
    switch( event.key ) {
        case "Enter":
          if (this.props.case === 'belowLowestSalePrice') {
            this.props.closeC(); 
            this.props.ocmOpenModal();
          }
            break;
        default:
            break;
    }
}

  caseAction() {
    switch (this.props.case) {
      case 'removeItem':
        this.props.removeItem(this.props.index);
      case 'clearForm':
        this.props.clearForm();
    }
    this.props.closeC();
  }

  renderPrompt() {
    switch (this.props.case) {
      case "receiveformSaveSuccess":
        return <span>
          <Translate value={isVAK ? 'save_completed' : 'save_completed_navigate_to_new_receiving'} />
      </span>
      case 'notInWeightRange':
        return (
          <span>
            <Translate value="no_in_weight_range" />
            <div style={{ fontSize: '30px' }}>Weight Range: {`${this.props.selectedInventoryRow.MinWeightRange} ~ ${this.props.selectedInventoryRow.MaxWeightRange}`}</div>
          </span>
        );
      case 'confirmProductRepeat':
        return (
          <span>
            <Translate value="duplicate_product_promotion" />
          </span>
        );
      case 'convertUneven':
        return (
          <span>
            <Translate value="products_do_not_convert_evenly" />
          </span>
        );
      case 'removeItem':
        return (
          <span>
            <Translate value="Are_you_sure_you_want_to_remove_item?" />
          </span>
        );
      case 'clearForm':
        return (
          <span>
            <Translate value="Are_you_sure_you_want_to_clear_order?" />
          </span>
        );
      case 'noPermission':
        return (
          <span>
            <Translate value="You_do_not_have_permission" />
          </span>
        );
      case 'itemOutOfStock':
        return (
          <span>
            <Translate value="Item_is_out_of_stock" />
          </span>
        );
      case 'itemAlreadyInOrder':
        return (
          <span>
            <Translate value="msg_item_already_in_sales_order" />
          </span>
        );
      case 'addingDuplicate':
        return (
          <span>
            <h4><Translate value="msg_add_duplicate_item" /></h4>
          </span>
        );
      case 'completeSheet':
        return (
          <span>
            <Translate value="are_you_sure_you_want_to_complete_this_sheet?" />
            &nbsp;<Translate value="you_will_not_be_able_to_create_new_receivings_after" />
          </span>
        );
      case 'quantityZero':
        return (
          <span>
            <Translate value="value_has_been_left_0_Continue" />
          </span>
        );
      case 'noCustomerChosen':
        return (
          <span>
            <Translate value="please_choose_customer_first" />
          </span>
        );
      case 'zeroQuantity':
        return (
          <span>
            <h3><Translate value="quantity_cannot_have_a_zero_value" /></h3>
            {
              this.props.zeroArray.map((obj) => {
                return (
                  <Row>
                    <Col xs={6} xsOffset={3} className="centerStyle">
                      {obj.Name}
                    </Col>
                  </Row>
                );
              })
            }
          </span>
        );
      case 'zeroWeight':
        return (
          <span>
            <h3><Translate value="weight(s)_cannot_have_a_zero_value" /></h3>
          </span>
        );
      case 'zeroSerialNum':
        return (
          <span>
            <h3><Translate value="serial_no(s)_cannot_have_a_zero_value" /></h3>
          </span>
        );
      case 'belowRefPrice':
        return (
          <span>
            <h3><Translate value="your_current_sale_price_is_below_lowest_sale_price" /></h3>
            {/* <h3><Translate value="the_reference_is" /> <span className="warning">{this.props.rowEdited.RefPrice}</span></h3> */}
            {/* <h3><Translate value="the_reference_is" /> <span className="warning">{this.props.rowEdited.LowestSalePrice}</span></h3> */}
            <h3><Translate value="the_lowest_sale_price_is" /> <span className="warning">{this.props.rowEdited.LowestSalePrice}</span></h3>
            <h3><Translate value="your_current_sale_price_is" /> <span className="warning">{this.props.newPrice}</span></h3>
            <h3><Translate value="want_to_sale_at_current_price" />?</h3>
          </span>
        );
      case 'belowLowestSalePrice':
        return (
          <span>
            <h3><Translate value="your_current_sale_price_is_below_lowest_sale_price" /></h3>
            <h3><Translate value={isGGI ? "the_lowest_small_unit_sale_price_is" : "the_lowest_sale_price_is"} /> <span className="warning">{this.props.lowestSalePrice}</span></h3>
            <h3><Translate value={isGGI ? "your_current_small_unit_sale_price_is" : "your_current_sale_price_is"} /> <span className="warning">{this.props.currentPrice}</span></h3>
            <h3><Translate value="want_to_sale_at_current_price" />?</h3>
          </span>
        );
      case 'belowLowestSalePriceAndDuplicate':
        return (
          <span>
            {/* <h3><Translate value="msg_add_duplicate_item" /></h3>
            <br /> */}
            <h3><Translate value="your_current_sale_price_is_below_lowest_sale_price" /></h3>
            <h3><Translate value="the_lowest_sale_price_is" /> <span className="warning">{this.props.lowestSalePrice}</span></h3>
            <h3><Translate value="your_current_sale_price_is" /> <span className="warning">{this.props.currentPrice}</span></h3>
            <h3><Translate value="want_to_sale_at_current_price" />?</h3>
          </span>
        );
      case 'confirmPassword':
        return (
          <span>
            <h3><Translate value="type_in_your_password" /></h3>
          </span>
        );
      case 'inputTotalBoxes':
        return (
          <span>
            <h3><Translate value="input_total_boxes" /></h3>
          </span>
        )
      case 'editSOPermission':
        return (
          <span>
            <h3><Translate value="msg_ask_for_manager_login" /></h3>
          </span>
        );
      case 'editRecPermission':
        return (
          <span>
            <h3><Translate value="msg_ask_for_manager_login" /></h3>
          </span>
        );
      case 'editDeliveryFeeRate':
        return (
          <span>
            <h3><Translate value="msg_ask_for_manager_login" /></h3>
          </span>
        );
      case 'voidStatus':
        return (
          <span>
            <h3>
              {
                (this.props.apNum) ?
                  <div>
                    <Translate value={this.props.voidStatus} />
                    <span>{this.props.apNum}</span>
                    <Translate value={this.props.voidStatusEnd} />
                  </div>
                : <Translate value={this.props.voidStatus} />
              }
            </h3>
          </span>
        );
      case 'chooseGroup':
        return (
          <span>
            <h3><Translate value="please_choose_customers_group" /></h3>
          </span>
        );
      case 'chooseTimePeriod':
        return (
          <span>
            <h3><Translate value="please_choose_start_date_and_end_date" /></h3>
          </span>
        );
      case 'chooseItemTwo':
        return (
          <span>
            <h3><Translate value="please_choose_item_b" /></h3>
          </span>
        );
      case 'chooseItemOne':
        return (
          <span>
            <h3><Translate value="please_choose_an_item_for_promotion" /></h3>
          </span>
        );
      case 'zerototalPrice':
        return (
          <span>
            <Translate value="total_price_cannot_be_zero" />
          </span>
        );
      case 'paymentTermMissing':
        return (
          <span>
            <Translate value="select_payment_term_first" />
          </span>
        );
      case 'confirmRefund':
        return (
          <span>
            <Translate value="msg_confirm_refund_order" />
          </span>
        );
      case 'deleteGroup':
        return (
          <span>
            <Translate value="msg_confirm_delete" />
          </span>
        );
      case 'addCustToGroup':
        return (
          <span>
            <Translate value="msg_confirm_add_customer_to_group" />
          </span>
        );
      case 'groupChange':
        return (
          <span>
            <Translate value="msg_confirm_change_group_without_save_products" />
          </span>
        );
      case 'chooseProduct':
        return (
          <span>
            <Translate value="you_must_select_an_item" />
          </span>
        );
      case 'finalizeConfirm':
        return (
          <span>
            {isVAK ? <Translate value="finalize_selected_receiving_vak" /> : <Translate value="finalize_selected_receiving" />}
          </span>
        )
      case 'expired_batches':
        return (
          <span>
            <h3>There are expired batches:{this.props.expAr.toString()}. Do you want to ignore them?</h3>
          </span>
        )
      case 'delete_picker':
        return(
          <span>
            <h3>This picker has associated orders, are you sure to delete it?</h3>
          </span>
        )
      case 'save_with_review_and_approve':
        return (
          <span>
            <h3><Translate value="msg_save_successfully"/></h3>
          </span>
        )
      case 'set_review_success':
        return (
          <span>
            <h3><Translate value="msg_mfg_set_review_success"/></h3>
          </span>
        )
      case 'set_approve_success':
        return (
          <span>
            <h3><Translate value="msg_mfg_set_approve_success"/></h3>
          </span>
        )
      case 'review_success':
        return (
          <span>
            <h3><Translate value={this.props.isApproved ? "msg_mfg_review_success" : "msg_mfg_review_ap_success"}/></h3>
          </span>
        )
      case 'approve_success':
        return (
          <span>
            <h3><Translate value="msg_mfg_approve_success" /></h3>
          </span>
        )
      case 'reject_review':
      case 'reject_approve':
        return (
          <span>
            <h3><Translate value="msg_mfg_reject_success"/></h3>
          </span>
        )
      case 'set_review':
        return (
          <span>
            <h3>
              <Translate value="msg_ask_if_confirm_to_set_review" />
            </h3>
          </span>
        )
      case 'set_approve':
        return (
          <span>
            <h3>
              <Translate value="msg_ask_if_confirm_to_set_approve"/>
            </h3>
          </span>
        )
      case 'set_recheck':
        return (
          <span>
            <h3>
              <Translate value="mfg_set_recheck"/>
            </h3>
          </span>
        )
      case 'confirm_review':
        return (
          <span>
            <h3><Translate value="msg_ask_if_confirm_to_review"/></h3>
          </span>
        )
      case 'confirm_approve':
        return (
          <span>
            <h3><Translate value="msg_ask_if_confirm_to_approve"/></h3>
          </span>
        )
      default:
        return (
          this.props.case || null
        );
    }
  }

  renderButtons() {
    switch (this.props.case) {
      case 'receiveformSaveSuccess':
        return (
          <span>
            <Button bsStyle="primary" className="mt mr" onClick={() => { this.props.caseAction(); }}><Translate value="yes" /></Button>
            <Button bsStyle="danger" className="mt mr" onClick={() => { this.props.closeC() }}><em className="fa fa-close" /><Translate value="no" /></Button>
            <Button bsStyle="primary" className="mt mr" onClick={() => { this.props.print() }}><em className="fa fa-print" /><Translate value="print" /></Button>
          </span>
        )
      case 'noPermission':
      case 'itemOutOfStock':
      case 'itemAlreadyInOrder':
      case 'noCustomerChosen':
      case 'zeroQuantity':
      case 'zeroWeight':
      case 'quantityZero':
      case 'convertUneven':
      case 'chooseGroup':
      case 'chooseTimePeriod':
      case 'chooseItemTwo':
      case 'chooseItemOne':
      case 'zerototalPrice':
      case 'chooseProduct':
        return (
          <Button bsStyle="primary" className="mt mr" onClick={this.props.closeC}><em className="fa fa-check" /><Translate value="Confirm" /></Button>
        );
      case 'confirmPassword':
        return (
          <span>
            <div className="col-xs-4 col-xs-offset-4"><Input type="password" ref={(input) => this.input = input} /></div>
            <div className="col-xs-1 col-xs-offset-5" style={{ marginTop: '50px' }}><Button bsStyle="primary" className="mt mr" onClick={() => { this.props.closeC(this.input.refs.input.value); }}><em className="fa fa-check" /><Translate value="Confirm" /></Button></div>
          </span>
        );
      case 'inputTotalBoxes':
        return (
          <span>
            <div className="col-xs-4 col-xs-offset-4"><Input type="text" ref={(input) => this.input = input} /></div>
            <div className="col-xs-4 col-xs-offset-4" style={{ marginTop: '50px' }}><Button bsStyle="primary" className="mt mr" onClick={() => { this.props.closeC(this.input.refs.input.value); }}><em className="fa fa-check" /><Translate value="Confirm" /></Button></div>
          </span>
        )
      case 'editSOPermission':
        return (
          <span>
            <div className="col-xs-4 col-xs-offset-4"><label><Translate value="username" /></label><Input type="text" ref={(input) => this.inputText = input}/></div>
            <div className="col-xs-4 col-xs-offset-4"><label><Translate value="password" /></label><Input type="password" ref={(input) => this.inputPassword = input}/></div>
            <div className="col-xs-1 col-xs-offset-5"><Button bsStyle="primary" className="mt mr" onClick={() => { this.props.checkPermission(this.inputText.refs.input.value, this.inputPassword.refs.input.value); }}><em className="fa fa-check" /><Translate value="submit" /></Button></div>
          </span>
        );
      case 'editRecPermission':
        return (
          <span>
            <div className="col-xs-4 col-xs-offset-4"><label><Translate value="username" /></label><Input type="text" ref={(input) => this.inputText = input}/></div>
            <div className="col-xs-4 col-xs-offset-4"><label><Translate value="password" /></label><Input type="password" ref={(input) => this.inputPassword = input}/></div>
            <div className="col-xs-1 col-xs-offset-5"><Button bsStyle="primary" className="mt mr" onClick={() => { this.props.checkPermission(this.inputText.refs.input.value, this.inputPassword.refs.input.value); }}><em className="fa fa-check" /><Translate value="confirm" /></Button></div>
          </span>
        );
      case 'editDeliveryFeeRate':
        return (
          <span>
            <div className="col-xs-4 col-xs-offset-4"><label><Translate value="username" /></label><Input type="text" ref={(input) => this.inputText = input}/></div>
            <div className="col-xs-4 col-xs-offset-4"><label><Translate value="password" /></label><Input type="password" ref={(input) => this.inputPassword = input}/></div>
            <div className="col-xs-1 col-xs-offset-5"><Button bsStyle="primary" className="mt mr" onClick={() => { this.props.checkPermission(this.inputText.refs.input.value, this.inputPassword.refs.input.value); }}><em className="fa fa-check" /><Translate value="confirm" /></Button></div>
          </span>
        );
      case 'addingDuplicate':
      case 'notInWeightRange':
        return (
          <span>
            <Button bsStyle="primary" className="mt mr" onClick={() => { this.props.caseAction(); this.props.closeC(); }}><Translate value="continue" /></Button>
            <Button bsStyle="danger" className="mt mr" onClick={() => { this.props.closeC(); }}><em className="fa fa-close" /><Translate value="cancel" /></Button>
          </span>
        );
      case 'voidStatus':
        return (
          <span />
        );
      case 'completeSheet':
        return (
          <span>
            <Button bsStyle="primary" className="mt mr" onClick={() => { this.props.caseAction(this.props.formProps) }}><Translate value="Confirm" /></Button>
            <Button bsStyle="danger" className="mt mr" onClick={() => { this.props.closeC(); }}><em className="fa fa-close" /><Translate value="Cancel" /></Button>
          </span>
        );
      case 'paymentTermMissing':
        return (
          <span>
            <Button bsStyle="primary" className="mt mr" onClick={() => { this.props.closeC(); }}><Translate value="Confirm" /></Button>
          </span>
        );
      case 'confirmRefund':
        return (
          <span>
            <Button bsStyle="primary" className="mt mr" onClick={() => { this.props.handleRefundConfirm(); this.props.closeConfirmRefund(); }}><em className="fa fa-check" /><Translate value="Confirm" /></Button>
            <Button bsStyle="danger" className="mt mr" onClick={() => { this.props.closeConfirmRefund(); }}><em className="fa fa-close" /><Translate value="Cancel" /></Button>
          </span>
        );
      case 'belowRefPrice':
        return (
          <span>
            <Button bsStyle="primary" className="mt mr" onClick={() => { this.props.updatePrice(); this.props.closeC(); }}><em className="fa fa-check" /><Translate value="Confirm" /></Button>
            <Button bsStyle="danger" className="mt mr" onClick={() => { this.props.closeC(); }}><em className="fa fa-close" /><Translate value="Cancel" /></Button>
          </span>
        );
      case 'belowLowestSalePrice':
        return (
          <span>
            <Button bsStyle="primary" name="ats" id="ats" className="mt mr" onClick={() => { this.props.closeC(); this.props.ocmOpenModal();}}><em className="fa fa-check" /><Translate value="Confirm" /></Button>
            <Button bsStyle="danger" className="mt mr" onClick={() => { this.props.closeC(); }}><em className="fa fa-close" /><Translate value="Cancel" /></Button>
          </span>
        );
      case 'expired_batches':
        return (
          <span>
            <Button bsStyle="primary" className="mt mr" onClick={() => { this.props.closeC(); this.props.expiredConfirm();}}><em className="fa fa-check" /><Translate value="Confirm" /></Button>
            <Button bsStyle="danger" className="mt mr" onClick={() => { this.props.closeC(); }}><em className="fa fa-close" /><Translate value="Cancel" /></Button>
          </span>
        );
      case 'delete_picker':
        return (
          <span>
            <Button bsStyle="primary" className="mt mr" onClick={() => { this.props.closeC(); this.props.deletePickerConfirm();}}><em className="fa fa-check" /><Translate value="Confirm" /></Button>
            <Button bsStyle="danger" className="mt mr" onClick={() => { this.props.closeC(); }}><em className="fa fa-close" /><Translate value="Cancel" /></Button>
          </span>
        );
      case 'finalizeConfirm':
        return (
          <span>
            <Button bsStyle="primary" className="mt mr" onClick={this.props.onConfirm}><em className="fa fa-check" /><Translate value="Confirm" /></Button>
            <Button bsStyle="danger" className="mt mr" onClick={this.props.onCancel}><em className="fa fa-close" /><Translate value="Cancel" /></Button>
          </span>
        )
      case 'save_with_review_and_approve':
      case 'review_success':
      case 'approve_success':
        return (
          <span>
            {this.props.isApproved && <Button bsStyle="primary" className="mt mr" onClick={this.props.onConfirm}><em className="fa fa-check" /><Translate value="Confirm" /></Button>}
            {this.props.onSetReview && <Button bsStyle="primary" className="mt mr" onClick={this.props.onSetReview}><em className="fa fa-eye" /><Translate value="mfg_set_review" /></Button>}
            {this.props.onSetRecheck && <Button bsStyle="primary" className="mt mr" onClick={this.props.onSetRecheck}><Translate value="yes" /></Button>}
            {this.props.onSetApprove && <Button bsStyle="primary" className="mt mr" onClick={this.props.onSetApprove}><Translate value="no" /></Button>}
          </span>
        )
      case 'set_review':
      case 'set_approve':
        return (
          <span>
            <Button bsStyle="primary" className="mt mr" onClick={this.props.onConfirm}><em className="fa fa-check" /><Translate value="confirm" /></Button>
            <Button bsStyle="danger" className="mt mr" onClick={this.props.onCancel}><em className="fa fa-close" /><Translate value="cancel" /></Button>
          </span>
        )
      case 'confirm_review':
      case 'confirm_approve':
        return (
          <span>
            <Button bsStyle="primary" className="mt mr" onClick={this.props.onConfirm}><em className="fa fa-check" /><Translate value="confirm_review" /></Button>
            <Button bsStyle="danger" className="mt mr" onClick={this.props.onReject}><em className="fa fa-close" /><Translate value="reject_review" /></Button>
          </span>
        )
      case 'set_review_success':
      case 'set_approve_success':
      case 'reject_review':
      case 'reject_approve':
        return (
          <span>
            <Button bsStyle="primary" className="mt mr" onClick={this.props.onConfirm}><em className="fa fa-check" /><Translate value="Confirm" /></Button>
          </span>
        )
      case 'set_recheck':
        return (
          <span>
            <div className="form-group">
              <label className="col-xs-3"><Translate value="reviewer"/></label>
              <Select className={'col-xs-8 Select testSelect Select--single'} options={this.props.userOptions || []} onChange={(selected => this.setState({selected}))} value={this.state.selected} /></div>
            <div className="col-xs-12" style={{ marginTop: '10px' }}>
              <Button bsStyle="primary" className="mt mr" onClick={() => {this.props.onConfirm && this.props.onConfirm(this.state.selected)}}><em className="fa fa-check"/><Translate value="Confirm"/></Button>
              <Button bsStyle="danger" className="mt mr" onClick={this.props.onCancel}><em className="fa fa-close" /><Translate value="Cancel" /></Button>
            </div>
          </span>
        )
      default:
        return (
          <span>
            <Button bsStyle="primary" className="mt mr" onClick={() => {
              this.props.caseAction();
              this.props.closeC();
            }}><em className="fa fa-check"/><Translate value="Confirm"/></Button>
            <Button bsStyle="danger" className="mt mr" onClick={() => { this.props.closeC(); }}><em className="fa fa-close" /><Translate value="Cancel" /></Button>
          </span>
        )
    }
  }

  render() {
    const { closeC, checkPasswordFailure, checkPermissionSuccess } = this.props;
    return (
      <ContentWrapper>
        <Row>
          <Col sm={12} className="text-center" style={{ marginTop: this.props.case === 'set_recheck' ? 'unset' : '20px' }}>
            {this.renderPrompt()}
          </Col>
        </Row>
        <Row>
          <Col sm={12} className="text-center">
            {this.renderButtons()}
          </Col>
        </Row>
        <br />
        {checkPasswordFailure && <Row className="text-center alert alert-danger"><Translate value="your_password_is_not_correct" /></Row>}
        {checkPermissionSuccess && !checkPermissionSuccess.manager && <Row className="text-center alert alert-danger"><Translate value="no_permission" /></Row>}
      </ContentWrapper>
    );
  }
}

export default ConfirmActionModal;



// WEBPACK FOOTER //
// ./master/jsx/components/Common/confirmActionModal.jsx